import { createSelector } from 'reselect';
import { RootState } from '../index';

const loginReducerSelector = (state: RootState) => state.auth;

export const auth_loader = createSelector(loginReducerSelector, (login) => login.loader);

export const auth_hasJwtToken = createSelector(loginReducerSelector, (login) => login.hasJwtToken);
